import React from 'react';
import { MoreTimeOutlinedIcon } from 'element';
import { Tooltip } from 'oxygen-elements';
import { blue } from '../../lib/styles';

interface OvertimeIconProps {
  isOvertime?: boolean;
  tooltipTitle?: string;
}

export const OvertimeIcon: React.FC<OvertimeIconProps> = ({ 
  isOvertime = false,
  tooltipTitle = "Overtime shift" 
}) => {
  if (!isOvertime) {
    return null;
  }

  return (
    <Tooltip title={tooltipTitle}>
      <MoreTimeOutlinedIcon 
        style={{ 
          color: blue,
          display: 'inline-block',
          marginLeft: '8px',
          verticalAlign: 'middle'
        }} 
      />
    </Tooltip>
  );
};